import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchSpecialRequests } from "../actions/fetchSpecialRequests.actions";
import { selectCategory } from "../../../../../../../../../redux/features/quotes/quote-create-advanced/selectors/sectorWorkflowSelectors";
import { useAppSelector } from "../../../../../../../../../redux/hooks/redux";

export const useSpecialRequestsPagination = () => {
  const [page, setPage] = useState(1);
  const category = useAppSelector(selectCategory);
  const categoryParam = category?.uid ?? category?.name ?? "";

  useEffect(() => {
    setPage(1);
  }, [categoryParam]);

  const query = useQuery({
    queryKey: ["special-requests", page, categoryParam],
    queryFn: () =>
      fetchSpecialRequests(page, 10, categoryParam ? { category: categoryParam } : undefined),
    enabled: !!(category?.uid || category?.name),
  });

  const goNextPage = () => {
    if (query.data && page < query.data.totalPages) {
      setPage((p) => p + 1);
    }
  };

  const goPrevPage = () => {
    if (page > 1) {
      setPage((p) => p - 1);
    }
  };

  return {
    ...query,
    items: query.data?.items ?? [],
    page,
    totalPages: query.data?.totalPages ?? 1,
    goNextPage,
    goPrevPage,
  };
};
